import React, { FC } from 'react';
import { Button } from '@fiverr-private/button';
import { PlusIcon } from '@fiverr-private/icons';
import { I18n } from '@fiverr-private/i18n-react';

import { T_KEY } from '../../utils';

interface AddWorkExperienceButtonProps {
    onClick: () => void;
}

const AddWorkExperienceButton: FC<AddWorkExperienceButtonProps> = ({ onClick }) => (
    <Button intent="secondary" variant="outline" onClick={onClick} data-testId="add-experience-button-manually">
        <PlusIcon size={12} />
        <I18n k={`${T_KEY}.empty.add_button`} />
    </Button>
);

export default AddWorkExperienceButton;
